/* ==========================================================================
  main.js
========================================================================== */

var update = function update() {
  document.body.dataset.scroll = window.scrollY;
};

document.addEventListener('scroll', update, {
  passive: true
});
update();

/**
 * Navigation
 */
aucor_navigation(document.getElementById('primary-navigation'), {
  desktop_min_width: 1280, // min width in pixels
  menu_toggle: '#menu-toggle' // selector for toggle
});

/**
 * Responsive videos
 */
fitvids();


// add jquery as dependency in functions.php and uncomment the following if you need jquery
 (function($) {
	$(document).ready(function(){
		// Convert the Alert coordinates reference system from ETRS-TM35FIN to WGS-84.
		KymenVesiMap.alerts.map( function( alert ) {
			if ( alert.geometry.location_geojson ) {
				alert.geometry.location_geojson = JSON.parse( alert.geometry.location_geojson );
				alert.geometry.location_geojson.coordinates[0] = alert.geometry.location_geojson.coordinates[0].map( convertCoordinates );
			}
			return alert;


		});


		$('.map-filter').on('click', function(e) {
			e.preventDefault();
			var layer = $(this).data('layer');
			var activeClass = 'filter-active';
			$('.map-filter').removeClass( activeClass );
			$(this).addClass( activeClass );

			Object.entries( layerGroups ).forEach( function( value ) {
				value[1].clearLayers();
			});

			layerGroups.fault        = L.layerGroup( layerGroupsLayers.fault );
			layerGroups.normal_work  = L.layerGroup( layerGroupsLayers.normal_work );
			layerGroups.planned_work = L.layerGroup( layerGroupsLayers.planned_work );

			if ( layer === 'all' ) {
				Object.entries( layerGroups ).forEach( function( value ) {
					var key   = value[0];
					var group = value[1];
					group.addTo( map );
				});
			} else {
				layerGroups[layer].addTo( map );
			}

		});

		if ( $('#map').length > 0 ) {
			var map = L.map('map').setView([ 60.468097,26.900438 ], 12 );

			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
			}).addTo(map);

			var alertFeatures = KymenVesiMap.alerts.map( buildAlertFeature );
			alertFeatures = alertFeatures.filter( function(alertFeature) {
				return alertFeature;
			} );

			var layerGroupsLayers = {
				fault: [],
				normal_work: [],
				planned_work: [],
			};

			var layerGroups = {
				fault: null,
				normal_work: null,
				planned_work: null,
			};
			var layerGroupsLabels = {
				fault: 'Häiriö',
				normal_work: 'Rakennuskohde',
				planned_work: 'Suunniteltu keskeytys'
			};

			L.geoJSON(alertFeatures, {
				style: {
					// color: "#ff0000",
					// fillColor: "orange",
					fillColor: "#3a81da",
					weight: 2,
					opacity: 1,
					// color: "red",
					color: "#07486b",
					dashArray: '3',
					fillOpacity: 0.5
				},
				onEachFeature: function( feature, layer ) {
					var popupContent = '<strong>' + feature.properties.title + '</strong><br><br>' +
					feature.properties.description + '<br><br>' +
					feature.properties.begin + ' – ' + feature.properties.end + '<br><br>';
					// Get bounds of polygon
					var bounds = layer.getBounds();
					// Get center of bounds
					var center = bounds.getCenter();
					// Use center to put marker on map
					// var marker = L.marker(center).addTo(layer).bindPopup( popupContent );
					var marker = L.marker(center).bindPopup( popupContent );

					layer.bindPopup( popupContent ).openPopup();

					layerGroupsLayers[ feature.properties.category ].push( marker );
					layerGroupsLayers[ feature.properties.category ].push( layer );
				}
			});
			layerGroups.fault        = L.layerGroup( layerGroupsLayers.fault );
			layerGroups.normal_work  = L.layerGroup( layerGroupsLayers.normal_work );
			layerGroups.planned_work = L.layerGroup( layerGroupsLayers.planned_work );

			Object.entries( layerGroups ).forEach( function( value ) {
				var key   = value[0];
				var group = value[1];
				group.addTo( map );
			});
		}
	});
 })(jQuery);

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){

    // current <img> element
    var el = e.target;

    objectFitPolyfill();
    el.addEventListener('load', function() {
      objectFitPolyfill();
    });
  });
}

/**
 * Convert coordinates from ETRS-TM35FIN to WGS-84.
 *
 * @param latLng latLng Latitude/Longitude in ETRS-TM35FIN.
 * @return object Latitude/Longitude in WGS-84.
 */
function convertCoordinates( latLng ) {
	// WGS-84
	var wgsProjection = "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs";
	// ETRS-TM35FIN
	var EtrsTm35FinProjection = "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs";

	var wgs84 = proj4( EtrsTm35FinProjection,wgsProjection, latLng );

	return [ wgs84[0], wgs84[1] ];
}

/**
 * Build the alert leaflet feature list.
 * @param object alert Alert object.
 * @param object Feature GeoJSON object.
 */
function buildAlertFeature( alert ) {

	if ( alert.geometry.location_geojson && alert.geometry.location_geojson.coordinates ) {
		return {
			"type": "Feature",
			"properties": {
				"title": alert.title,
				"begin": alert.begin,
				"end": alert.end,
				"description": alert.description,
				"category": alert.category.slug,
				"party": "Democrat"
			},
			"geometry": {
				"type": "Polygon",
				"coordinates": alert.geometry.location_geojson.coordinates
			}
		};
	}
	return false;
}
